import { defineMessages } from 'react-intl';

export const scope = 'app.base.component.dropdown';

export default defineMessages({
  create_new: {
    id: `${scope}.create_new`,
    defaultMessage: 'Create New',
  },
});
